import React, { useContext, useEffect, useState } from 'react'
import ProjectContext from '../../../context/ProjectContext'

export const RightMenuTop = () => {

    const calculateDuration = (duration) => {
        var tempArr = duration.split(':');
        var hours = parseInt(tempArr[0]);
        var minutes = parseInt(tempArr[1]);
        var seconds = parseInt(tempArr[2]);
        var milliseconds = parseInt(tempArr[3]);
        var totalMilliseconds = ((hours * 60 * 60 + minutes * 60 + seconds) * 1000) + milliseconds;
        return (Math.round(totalMilliseconds));
    }

    const msToTime = (duration) => {
        var seconds = Math.floor((duration / 1000) % 60),
            minutes = Math.floor((duration / (1000 * 60)) % 60),
            minutes = (minutes < 10) ? "0" + minutes : minutes;
        seconds = (seconds < 10) ? "0" + seconds : seconds;
        return minutes + ":" + seconds;
    }

    const { slides } = useContext(ProjectContext)

    useEffect(() => {
        projectTime()
    }, [slides]);

    const projectTime = (params) => {

        var time = 0;
        for (const itr of slides) {
            time += calculateDuration(itr.TotalLength)
        }

        setTime(msToTime(time))
    }

    const [Time, setTime] = useState('0:10');

    return (
        <div className="slidesMenuTop">
            <div className="pop">
                <div className="popArrow">
                    <span className="material-icons">
                        navigate_next
                    </span>
                </div>
            </div>
            <div className="slideTopTittle">
                <div className="tittleicon" onClick={() => { }}>
                    <span className="material-icons">
                        slideshow
                    </span> Slides
                </div>
                {Time}
            </div>

        </div>

    )
}
export default RightMenuTop;